"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEventAnalytics = void 0;
var react_1 = require("react");
var useWebAnalytics_1 = require("./useWebAnalytics");
var env_1 = require("../utils/env");
/**
 * Enrich the given context fields with internal ADA React framework fields
 * @param eventFieldMap
 * @returns
 */
function enrichEventFieldMap(eventFieldMap) {
    var internalFields = {
        event_api: 'react-observe-event',
    };
    return __assign(__assign({}, eventFieldMap), internalFields);
}
/**
 * See [useEventAnalytics](https://gitlab.agodadev.io/full-stack/fe-data/analytics-data-acquisition/-/tree/master/packages/analytics-data-acquisition-react?ref_type=heads#useeventanalytics) for more information.
 *
 * @param idMap
 * @param eventFieldMap
 * @param options
 * @returns
 */
function useEventAnalytics(idMap, eventFieldMap, options) {
    var _a = options !== null && options !== void 0 ? options : {}, optionalDependencyArray = _a.optionalDependencyArray, disableObservation = _a.disableObservation;
    var webAnalytics = (0, useWebAnalytics_1.useWebAnalytics)();
    /**
     * By default, we do not put idMap and eventFieldMap in dependency array
     * Because, for useEventAnalytics, the eventFieldMap is usually an object that contain either a getDomAttribute function or primitive literal
     * So the reference of eventFieldMap will always be different BUT the value will be the same
     * If we put eventFieldMap in dependency array AND developer DO NOT use useMemo on eventFieldMap, it will always trigger useEffect
     * Which could lead to performance issue or unexpected behavior
     * Similar for idMap, the value should come from our message definition so the value should be stable
     *
     * In rare cases where developer really need to re-observe element, they can pass optionalDependencyArray
     */
    (0, react_1.useEffect)(function () {
        if (disableObservation) {
            return;
        }
        if (webAnalytics) {
            webAnalytics.observe(idMap, enrichEventFieldMap(eventFieldMap));
        }
        else {
            var errorMessage = "Cannot observe event for ".concat(JSON.stringify(idMap, null, 2), ". Please ensure the component is wrapped with WebAnalyticsProvider and the webAnalytics is NOT undefined.\n\nFor details on how to fix it, please refer to https://gitlab.agodadev.io/full-stack/fe-data/analytics-data-acquisition/-/tree/master/packages/analytics-data-acquisition-react?ref_type=heads#how-to-fix-cannot-observe-eventelement-for-please-ensure-the-component-is-wrapped-with-webanalyticsprovider-and-the-webanalytics-is-not-undefined-error");
            if ((0, env_1.isProduction)()) {
                console.error(errorMessage);
            }
            else {
                throw new Error(errorMessage);
            }
        }
    }, optionalDependencyArray !== null && optionalDependencyArray !== void 0 ? optionalDependencyArray : []);
    return undefined;
}
exports.useEventAnalytics = useEventAnalytics;
